<template>
  <div class="view-profile">

    <h1 class="subtitle-1 grey--text">Documentation</h1>
    <p>Coming soon...</p>

  </div>
</template>

<script>

export default {
  name: 'Docs',
  data(){
    return{
    }
  },
  created(){
  }
}
</script>

<style>

</style>

